import React, { ReactNode } from 'react'
import styled from 'styled-components'
import breakpoints from '../../../styles/breakpoints'
import { fonts } from '../../../styles/theme'
import Muted from '../typography/muted'

const StyledFieldset = styled.fieldset`
  display: contents;
`

const Section = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: ${props => props.theme.spacing.base700};

  border-top: 1px solid ${props => props.theme.colors.separator};
  padding-top: ${props => props.theme.spacing.base300};
  margin-top: ${props => props.theme.spacing.base600};

  @media (min-width: ${breakpoints.lg}) {
    grid-template-columns: 1fr 2fr;
  }
`

const Legend = styled.legend`
  @media (max-width: ${breakpoints.lg}) {
    margin-bottom: ${props => props.theme.spacing.base600};
  }
`

const LegendTitle = styled.h6`
  font-family: ${fonts.raleway};
  line-height: 1.75;
  margin-top: 0;
  margin-bottom: 0.25rem;
`

const LegendDescription = styled(Muted)`
  margin: 0;
`

const FieldsetInputs = styled.div``

const Fieldset = ({
  legendTitle,
  legendDescription,
  children,
  ...props
}: {
  legendTitle: string | ReactNode
  legendDescription: string | ReactNode
  children: any
} & any) => (
  <StyledFieldset {...props}>
    <Section>
      <Legend>
        <LegendTitle>{legendTitle}</LegendTitle>
        <LegendDescription as="p">{legendDescription}</LegendDescription>
      </Legend>

      <FieldsetInputs>{children}</FieldsetInputs>
    </Section>
  </StyledFieldset>
)

export default Fieldset
